export default __webpack_public_path__ + "static/media/bchain.900e0d57.png";